<ng-container *transloco="let t; read: 'not_found'">
  <div class="p-d-flex p-flex-column p-jc-center p-ai-center" style="height: 100vh;">
    <p class="ondark p-text-center"><fa-icon class="p-pb-4 icon" [icon]="faEngineWarning"></fa-icon></p>
    <h1 class="p-text-center">
      {{ t('title') }}
    </h1>
    <div>
      <p class="ondark p-text-center" [innerHtml]="t('ac_not_found')"></p>
    </div>
  </div>
</ng-container>
